@if (authService.hasPermission(Permission.PostAssetsFull)) {
  <mat-form-field subscriptSizing="dynamic" appearance="outline">
    <mat-label>View</mat-label>
    <mat-select [ngModel]="postView" (ngModelChange)="onViewChange($event)">
      <mat-option value="selects"> Selects </mat-option>
      <mat-option value="all"> All </mat-option>
    </mat-select>
  </mat-form-field>
}
